import React from "react";

const TabNavigation = ({ activeTab, onTabChange }) => {
  return (
    <div className="hubspot-tabs">
      <button
        className={`hubspot-tab ${activeTab === "Mapping" ? "active" : ""}`}
        onClick={() => onTabChange("Mapping")}
      >
        Mapping
      </button>
      <button
        className={`hubspot-tab ${activeTab === "Automation & Alerts" ? "active" : ""}`}
        onClick={() => onTabChange("Automation & Alerts")}
      >
        Automation & Alerts
      </button>
    </div>
  );
};

export default TabNavigation;
